import { ReactNode } from "react";

export const mainNavIcon: {
  [key: string]: { icon: ReactNode; activeIcon: ReactNode };
} = {
  view: {
    icon: (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.74902 15.2542L16.5496 4.95453L29.3503 15.2542"
          stroke="#EA27C2"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
        <path
          d="M6.49463 13.8018V27.0454H26.609V13.8018"
          stroke="#EA27C2"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
        <path
          d="M16.5498 16.8415L16.5498 20.9115"
          stroke="#EA27C2"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
      </svg>
    ),
    activeIcon: (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.2168 13.015L16.5396 5.14894L25.8623 13.015V26.635H7.2168V13.015Z"
          fill="#132029"
        />
        <path
          d="M3.75 15.2542L16.5506 4.95459L29.3512 15.2542"
          stroke="#132029"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
        <path
          d="M6.49609 13.8018V27.0453H26.6104V13.8018"
          stroke="#132029"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
        <path
          d="M16.5508 16.8418L16.5508 20.9117"
          stroke="white"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
      </svg>
    ),
  },
  talk: {
    icon: (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5496 4C9.92139 4 4.54956 9.13913 4.54956 15.4783C4.54956 18.9541 6.17217 22.0626 8.72347 24.1673L7.68 28L11.8539 26.0435C13.297 26.6299 14.8831 26.9565 16.5496 26.9565C23.1777 26.9565 28.5496 21.8174 28.5496 15.4783C28.5496 9.13913 23.1777 4 16.5496 4Z"
            stroke="#132029"
            strokeWidth="1.75"
            strokeLinejoin="round"
          />
          <path
            d="M8.83545 18.5714L14.8354 14.2857L18.264 16.8572L23.4069 12.5714"
            stroke="#132029"
            strokeWidth="1.75"
          />
        </g>
      </svg>
    ),
    activeIcon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 4C9.37183 4 4 9.13913 4 15.4783C4 18.9541 5.62261 22.0626 8.17391 24.1673L7.13043 28L11.3043 26.0435C12.7475 26.6299 14.3336 26.9565 16 26.9565C22.6282 26.9565 28 21.8174 28 15.4783C28 9.13913 22.6282 4 16 4Z"
          fill="#132029"
          stroke="#132029"
          strokeWidth="1.75"
          strokeLinejoin="round"
        />
        <path
          d="M8.28564 18.5714L14.2856 14.2857L17.7142 16.8572L22.8571 12.5714"
          stroke="white"
          strokeWidth="1.75"
        />
      </svg>
    ),
  },
  service: {
    icon: (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            d="M27.5498 25H5.5498M27.5498 7H5.5498"
            stroke="#132029"
            strokeWidth="1.75"
          />
          <path d="M27.5498 16H5.5498" stroke="#132029" strokeWidth="1.75" />
        </g>
      </svg>
    ),
    activeIcon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M27 25H5M27 7H5" stroke="#132029" strokeWidth="2" />
        <path d="M27 16H5" stroke="#132029" strokeWidth="2" />
      </svg>
    ),
  },
  myinfo: {
    icon: (
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.6962 9.4086C21.6962 12.2492 19.3924 14.5515 16.55 14.5515C13.7076 14.5515 11.4038 12.2492 11.4038 9.4086C11.4038 6.56803 13.7076 4.26575 16.55 4.26575C19.3924 4.26575 21.6962 6.56803 21.6962 9.4086Z"
            stroke="#132029"
            strokeWidth="1.75"
            strokeLinecap="square"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.1272 27.4242H7.97314C7.97314 26.2062 7.97314 25.0474 7.97314 23.9981C7.97314 21.1559 10.2772 18.8528 13.1194 18.8528H19.981C22.8231 18.8528 25.1272 21.1559 25.1272 23.9981C25.1272 25.0474 25.1272 26.2062 25.1272 27.4242Z"
            stroke="#132029"
            strokeWidth="1.75"
            strokeLinecap="square"
          />
        </g>
      </svg>
    ),
    activeIcon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1464 9.4086C21.1464 12.2492 18.8426 14.5515 16.0002 14.5515C13.1578 14.5515 10.854 12.2492 10.854 9.4086C10.854 6.56803 13.1578 4.26575 16.0002 4.26575C18.8426 4.26575 21.1464 6.56803 21.1464 9.4086Z"
          fill="#132029"
          stroke="#132029"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5774 27.4242H7.42334C7.42334 26.2062 7.42334 25.0474 7.42334 23.9981C7.42334 21.1559 9.72738 18.8528 12.5695 18.8528H19.4312C22.2733 18.8528 24.5774 21.1559 24.5774 23.9981C24.5774 25.0474 24.5774 26.2062 24.5774 27.4242Z"
          fill="#132029"
          stroke="#132029"
          strokeWidth="1.75"
          strokeLinecap="square"
        />
      </svg>
    ),
  },
  report: {
    icon: (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.5317 21.577L25.5317 1.40076L1.53174 1.40076L1.53174 21.577L10.1262 21.577L13.5317 25.4008L16.9394 21.577L25.5317 21.577Z"
            stroke="#132029"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M8.55902 16.7514C8.55902 14.3722 10.785 12.4435 13.531 12.4435C16.2769 12.4435 18.5029 14.3722 18.5029 16.7514"
            stroke="#132029"
            strokeWidth="1.5"
          />
          <path
            d="M18.4917 8.50726L18.5041 8.50726"
            stroke="#132029"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
          <path
            d="M8.55908 8.50726L8.57146 8.50726"
            stroke="#132029"
            strokeWidth="1.5"
            strokeLinecap="square"
          />
        </g>
      </svg>
    ),
    activeIcon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5317 24.1298L27.5317 3.95349L3.53174 3.95349L3.53174 24.1298L12.1262 24.1298L15.5317 27.9535L18.9394 24.1298L27.5317 24.1298Z"
          fill="url(#paint0_linear_21_1791)"
          stroke="url(#paint1_linear_21_1791)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M20.5035 14.0229C20.5035 16.4021 18.2775 18.3309 15.5315 18.3309C12.7856 18.3309 10.5596 16.4021 10.5596 14.0229"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M20.4922 10.0867L20.5046 10.0867"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M10.5596 10.0867L10.572 10.0867"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <defs>
          <linearGradient
            id="paint0_linear_21_1791"
            x1="19.9046"
            y1="27.9535"
            x2="17.8807"
            y2="8.64687"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EA27C2" />
            <stop offset="0.992254" stopColor="#E100A3" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_21_1791"
            x1="19.9046"
            y1="27.9535"
            x2="17.8807"
            y2="8.64687"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EA27C2" />
            <stop offset="0.992254" stopColor="#E100A3" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
};
